import { RecordUtils } from "@rsm-hcd/javascript-core";
import { Record } from "immutable";
import { NotebookShareScope } from "models/enumerations/notebooks/notebook-share-scope";
import { PermissionScope } from "models/enumerations/notebooks/permission-scope";
import { NotebookResourcePermission } from "models/interfaces/notebooks/notebook-resource-permission";
import NotebookPermissionPageRecord from "models/view-models/notebooks/notebook-permission-page-record";

const defaultValues: NotebookResourcePermission =
    RecordUtils.auditableDefaultValuesFactory<NotebookResourcePermission>({
        resourceType: undefined,
        resourceId: undefined,
        recipientType: undefined,
        recipientId: undefined,
        permission: PermissionScope.View,
        shareScope: NotebookShareScope.EntireNotebook,
        notebookPermissionPages: undefined,
    });

export default class NotebookResourcePermissionRecord
    extends Record(defaultValues)
    implements NotebookResourcePermission
{
    constructor(params?: Partial<NotebookResourcePermission>) {
        if (params == null) {
            params = Object.assign({}, defaultValues);
        }

        if (params.notebookPermissionPages != null) {
            params.notebookPermissionPages =
                params.notebookPermissionPages?.map(
                    (page: NotebookPermissionPageRecord) =>
                        RecordUtils.ensureRecord(
                            page,
                            NotebookPermissionPageRecord
                        )
                );
        }

        super(params);
    }

    public with(
        values: Partial<NotebookResourcePermission>
    ): NotebookResourcePermissionRecord {
        return new NotebookResourcePermissionRecord(
            Object.assign(this.toJS(), values)
        );
    }
}
